<script>
export default {
	props: ['title'],
	data: () => {
		return {
			//
		};
	},
};
</script>

<template>
	<button>{{ title }}</button>
</template>
